import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CourseAssignmentCompletionDocument } from './@types';

export function invalidateTeamCourseAssignments(
   assignee_teamid: number,
   documents: CourseAssignmentCompletionDocument[],
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest('patch', `/course_assignments/Team/invalidateAll/${assignee_teamid}`, {
      ...common,
      body: {
         documents,
      },
   });
}

type InvalidateTeamCourseAssignmentsErrorCode =
   | 'course_assignments.invalidate_team.team_not_found'
   | 'course_assignments.invalidate_team.insufficient_privileges';

invalidateTeamCourseAssignments.errorMessages =
   createErrorMessageTypeGuard<InvalidateTeamCourseAssignmentsErrorCode>();
